// extracted by mini-css-extract-plugin
export default {"header":"defaultPage_header__1oPNM","header__text":"defaultPage_header__text__nvknv"};